import { useTranslation } from 'react-i18next';
import React from 'react';
import { Select, Tooltip, Typography } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useClientOptions } from '../../hooks/client-options';

const { Title } = Typography;

export const SelectClient = ({
  clientId,
  setClientId,
  hideTitle = false,
}: {
  clientId?: string;
  setClientId: (value: string | undefined) => void;
  hideTitle?: boolean;
}) => {
  const { t, i18n } = useTranslation();

  const { clientsLoading, memoizedClientsOptions } = useClientOptions();

  return (
    <div
      style={{
        display: clientId ? 'none' : 'flex',
        alignItems: 'baseline',
        flexWrap: 'wrap',
      }}
    >
      {!hideTitle && (
        <Title level={5}>{t('createThought.selectClient')}:</Title>
      )}

      <Tooltip title={t('createThought.selectClientTip')}>
        <QuestionCircleOutlined style={{ margin: '0 10px' }} />
      </Tooltip>

      <Select
        style={{ width: 250 }}
        showSearch
        placeholder={t('createThought.selectClient')}
        optionFilterProp="children"
        loading={clientsLoading}
        value={clientId}
        onChange={(value) => {
          setClientId(value as string);
        }}
        filterOption={(input, option) =>
          (option!.children as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
        data-testid="cc-select-client-select"
      >
        {memoizedClientsOptions}
      </Select>
    </div>
  );
};
